// TelcoTrack — mustr textu „Předání odpovědnosti“ (Dokumenty / stavbyvedoucí).

import { formatPredaniLegalDate, formatPredaniZastupceLabel } from './predani-povrchu.util';

export interface PredaniOdpovednostiNoteInput {
  stavbaLabel: string;
  kiaCode?: string;
  predavajici: string;
  stavbyvedouci: string;
  /** YYYY-MM-DD */
  periodFrom: string;
  /** YYYY-MM-DD */
  periodTo: string;
  reason: string;
  /** YYYY-MM-DD */
  protocolDate: string;
  place: string;
}

export interface PredaniOdpovednostiPolygonFields {
  siteManager?: string | null;
  siteManagerUserId?: string | null;
  metadata?: Record<string, unknown> | null;
}

function diaryConfig(polygon: PredaniOdpovednostiPolygonFields): Record<string, unknown> | null {
  const dc = polygon.metadata?.['diaryConfig'];
  if (!dc || typeof dc !== 'object' || Array.isArray(dc)) return null;
  return dc as Record<string, unknown>;
}

/** Stavbyvedoucí jméno z `site_manager` / `diaryConfig.stavbyveduciName`. */
export function resolveStavbyvedouciLabel(polygon: PredaniOdpovednostiPolygonFields): string {
  const fromColumn = (polygon.siteManager ?? '').trim();
  if (fromColumn) return fromColumn;
  const diary = diaryConfig(polygon);
  const name = diary?.['stavbyveduciName'];
  return typeof name === 'string' ? name.trim() : '';
}

/** `site_manager_user_id` / `diaryConfig.stavbyveduciUserId`. */
export function resolveStavbyvedouciUserId(polygon: PredaniOdpovednostiPolygonFields): string {
  const fromColumn = (polygon.siteManagerUserId ?? '').trim();
  if (fromColumn) return fromColumn;
  const diary = diaryConfig(polygon);
  const id = diary?.['stavbyveduciUserId'];
  return typeof id === 'string' ? id.trim() : '';
}

export function formatPredaniOdpovednostiPeriod(fromIso: string, toIso: string): string {
  const from = formatPredaniLegalDate(fromIso);
  const to = formatPredaniLegalDate(toIso);
  if (!fromIso.trim() && !toIso.trim()) return '—';
  if (fromIso.trim() === toIso.trim() || !toIso.trim()) return `dne ${from}`;
  return `od ${from} do ${to}`;
}

/** Editovatelný text potvrzení. */
export function buildPredaniOdpovednostiNote(input: PredaniOdpovednostiNoteInput): string {
  const stavba = input.stavbaLabel.trim() || '…';
  const kia = (input.kiaCode ?? '').trim();
  const stavbaLine = kia ? `${stavba} (KIA ${kia})` : stavba;
  const predavajici = input.predavajici.trim() || '…';
  const stavbyvedouci = input.stavbyvedouci.trim() || '…';
  const period = formatPredaniOdpovednostiPeriod(input.periodFrom, input.periodTo);
  const reason = input.reason.trim() || '…';
  const place = input.place.trim() || '…';
  const protocol = formatPredaniLegalDate(input.protocolDate);

  return [
    `Předávající ${predavajici} předává a stavbyvedoucí ${stavbyvedouci} přebírá odpovědnost stavbyvedoucího za staveniště stavby ${stavbaLine}.`,
    '',
    `Stavbyvedoucí potvrzuje, že je srozuměn s tím, že v období ${period} budou na staveništi prováděny stavební práce bez jeho osobního dozoru (bez jeho fyzické přítomnosti), a že i za těchto okolností nese odpovědnost stavbyvedoucího podle stavebního zákona a předpisů o bezpečnosti a ochraně zdraví při práci, zejména za organizaci stavby, dodržování povolení a BOZP v rozsahu své funkce.`,
    '',
    `Důvod / rozsah prací bez dozoru: ${reason}`,
    '',
    'Toto potvrzení nenahrazuje stavební deník ani nezbavuje zhotovitele povinnosti práce řádně dokumentovat. Stavbyvedoucí si vyhrazuje právo práce zastavit, pokud zjistí ohrožení bezpečnosti, povolení nebo kvality díla.',
    '',
    'Potvrzení bylo přečteno, schváleno a na znak souhlasu podepsáno oběma stranami.',
    `V ${place} dne ${protocol}.`,
  ].join('\n');
}

export { formatPredaniZastupceLabel };
